import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ctaData: null,
            loading: true,
            error: null,
            inner: [
                {
                    id: 1,
                    icon: 'fa fa-check-square',
                    text: 'Completing projects on time & Following budget guidelines'
                },
                {
                    id: 2,
                    icon: 'fa fa-check-square',
                    text: 'Elevated quality of workmanship'
                },
                {
                    id: 3,
                    icon: 'fa fa-check-square',
                    text: 'Meeting diverse supplier requirements'
                },
                {
                    id: 4,
                    icon: 'fa fa-check-square',
                    text: 'Implementing appropriate safety precautions and procedures'
                },
            ]
        }
    }

    componentDidMount() {
        this.fetchCtaData();
    }

    fetchCtaData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
            const apiUrl = `${baseUrl}/api/cta-section`;

            console.log("Fetching CTA data from:", apiUrl);

            const response = await fetch(apiUrl);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            console.log("CTA API Response:", result);
            
            if (result.success && result.data) {
                this.setState({
                    ctaData: result.data,
                    loading: false
                });
            } else {
                throw new Error('Invalid data format from CTA API');
            }
            
        } catch (error) {
            console.error('Error fetching CTA data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    renderCtaContent() {
        const { ctaData, loading, error } = this.state;

        if (loading) {
            return (
                <div className="themesflat-content-box clearfix" data-margin="0 25% 0 4.5%" data-mobilemargin="0 0 0 4.5%">
                    <div className="text-center">
                        <div className="loading-spinner">Loading content...</div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="themesflat-content-box clearfix" data-margin="0 25% 0 4.5%" data-mobilemargin="0 0 0 4.5%">
                    <div className="text-center error-message">
                        <p>Error loading content: {error}</p>
                        <button 
                            onClick={this.fetchCtaData} 
                            className="themesflat-button bg-accent"
                        >
                            Retry
                        </button>
                    </div>
                </div>
            );
        }

        if (!ctaData) {
            return (
                <div className="themesflat-content-box clearfix" data-margin="0 25% 0 4.5%" data-mobilemargin="0 0 0 4.5%">
                    <div className="text-center">
                        <p>No content available</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="themesflat-content-box clearfix" data-margin="0 25% 0 4.5%" data-mobilemargin="0 0 0 4.5%">
                <div className="themesflat-headings style-1 clearfix">
                    <h2 className="heading">{ctaData.heading}</h2>
                    <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />                                               
                    <p className="sub-heading margin-top-30">{ctaData.description}</p>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={26} data-mobile={35} data-smobile={35} />
                
                {/* Render points from API */}
                {ctaData.points && ctaData.points.length > 0 && (
                    <div className="content-list">
                        <div className="themesflat-list has-icon style-1 icon-left clearfix">
                            <div className="inner">
                                {ctaData.points.map((point, index) => (
                                    <span className="item" key={index}>
                                        <span className="icon"><i className="fa fa-check-square" /></span>
                                        <span className="text">{point}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                
                {/* Render static points as fallback */}
                {(!ctaData.points || ctaData.points.length === 0) && (
                    <div className="content-list">
                        <div className="themesflat-list has-icon style-1 icon-left clearfix">
                            <div className="inner">
                                {this.state.inner.map(data => (
                                    <span className="item" key={data.id}>
                                        <span className="icon"><i className={data.icon} /></span>
                                        <span className="text">{data.text}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                
                <div className="themesflat-spacer clearfix" data-desktop={42} data-mobile={35} data-smobile={35} />
                <div className="elm-button">
                    <Link to={ctaData.getInTouchUrl || "/contact-01"} className="themesflat-button bg-white">
                        GET IN TOUCH
                    </Link>
                </div>
            </div>
        );
    }
    
    render() {
        return (
            <div className="row-about">
                <div className="container-fluid">
                    <div className="row equalize sm-equalize-auto">
                        <div className="col-md-6 half-background style-1"/>
                        <div className="col-md-6 bg-light-grey">
                            <div className="themesflat-spacer clearfix" data-desktop={64} data-mobile={60} data-smobile={60} />
                            {this.renderCtaContent()}
                            <div className="themesflat-spacer clearfix" data-desktop={75} data-mobile={60} data-smobile={60} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;